/* ===========================================================================
 * THE PASSWORD JUST TYPED, HANDED TO THE FORCED CHANGE ONCE (owner,
 * 2026-10-05: "first time access, user do not need to reenter current
 * password").
 *
 * A person signing in with a temporary password is sent straight to "Set a new
 * password", which asked for the temporary one again — a password they typed
 * seconds earlier. The server still needs it (`/auth/change-password`
 * re-authenticates), so the sign-in keeps it here, in MEMORY ONLY — never
 * localStorage or sessionStorage — until the change succeeds or the person
 * signs out. A reload loses it, and the page then shows the field again.
 * Read without consuming: React may run a state initialiser twice.
 * ======================================================================== */
let held: string | null = null;

/** Called by sign-in when the account must change its password. */
export function holdSignInPassword(password: string): void {
  held = password;
}

/** The held password, if any. */
export function heldSignInPassword(): string | null {
  return held;
}

/** After the change succeeds, on sign-out, or when the server refuses it. */
export function forgetSignInPassword(): void {
  held = null;
}
